import script from "./SlideDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SlideDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./SlideDrawer.vue?vue&type=style&index=0&id=b647dc56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b647dc56"]])

export default __exports__